module.exports = __webpack_public_path__ + "img/other.d46acd7a.jpg";